import { createSlice } from "@reduxjs/toolkit"
import { message } from "antd"

const initialState = {
  items: [], // mỗi item: { package, quantity }
}

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    // addToCart(state, action) {
    //   const { packageItem } = action.payload
    //   console.log(packageItem, "packageItem add to cart")
    //   const existingIndex = state.items.findIndex(
    //     item => item.package.package_id === packageItem.package_id,
    //   )

    //   if (existingIndex >= 0) {
    //     state.items[existingIndex].quantity += 1
    //   } else {
    //     state.items.push({ package: packageItem, quantity: 1 })
    //   }
    // },
    addToCart(state, action) {
      const { packageItem } = action.payload
      console.log(packageItem, "packageItem add to cart")

      if (state.items.length > 0) {
        const currentTypeSim = state.items[0].package.type_sim
        if (packageItem.type_sim !== currentTypeSim) {
          // ❌ khác loại sim -> không cho thêm
          message.warning("Vui lòng chọn cùng loại SIM")
          return
        }
      }

      const existingIndex = state.items.findIndex(
        item => item.package.package_id === packageItem.package_id,
      )

      if (existingIndex >= 0) {
        state.items[existingIndex].quantity += 1
      } else {
        state.items.push({ package: packageItem, quantity: 1 })
      }
    },
    addPackageToCart(state, action) {
      const { packageItem } = action.payload
      const existingIndex = state.items.findIndex(
        item => item.package.package_id === packageItem.package_id,
      )

      if (existingIndex >= 0) {
        state.items[existingIndex].quantity += 1
      } else {
        state.items.push({ package: packageItem, quantity: 1 })
      }
    },
    removeFromCart(state, action) {
      const package_id = action.payload // nhận trực tiếp số/string
      state.items = state.items.filter(
        item => item.package.package_id !== package_id,
      )
    },

    clearCart(state) {
      state.items = []
    },
    updateCartItemQuantity(state, action) {
      const { package_id, newQuantity } = action.payload

      const existingIndex = state.items.findIndex(
        item => item.package.package_id === package_id,
      )

      if (existingIndex >= 0 && newQuantity > 0) {
        state.items[existingIndex].quantity = newQuantity
      } else if (existingIndex >= 0 && newQuantity <= 0) {
        state.items.splice(existingIndex, 1)
      }
    },
  },
})

export const {
  addToCart,
  addPackageToCart,
  removeFromCart,
  clearCart,
  updateCartItemQuantity,
} = cartSlice.actions

export default cartSlice.reducer
